define( 'ANSI/UIComponents/ReadMore',[ 'jquery', 'eventManager', 'ANSI/Utility/SitecoreUtils' ], function (
    $,
    eventManager,
    sitecoreUtils
) {
    'use-strict';

    var readmore = {
        init: function () {
            eventManager.subscribe( 'SearchResultsLoadedEvent', function () {
                $( '.member-updates-page .js-read-more' )
                    .off( 'click' )
                    .on( 'click', function ( e ) {
                        e.preventDefault();

                        if ( $( this ).siblings( '.read' ).hasClass( 'read-less' ) ) {
                            $( '.read' ).addClass( 'read-less' );
                            $( '.js-read-more' ).text( 'Read More' );
                            $( this ).siblings( '.read' ).removeClass( 'read-less' );
                            $( this ).text( 'Read Less' );

                        } else {
                            $( this ).siblings( '.read' ).addClass( 'read-less' );
                            $( this ).text( 'Read More' );
                        }

                    } );
            } );
        },
    };

    if ( !sitecoreUtils.prototype.isEditing() )
        Promise.resolve().then( readmore.init );
} );
